import React, { Component } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Button, Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import NominaCatalogoManager from '../../../../catalogs/managers/NominaCatalogoManager';

class NominaDeduccionForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      TipoDeduccion: [
        'required',
        'string',
      ],
      Clave: ['required', 'string', 'min:3', 'max:15', 'regex:/^[^|]{3,15}$/'],
      Concepto: ['required', 'string', 'min:1', 'max:100', 'regex:/^[^|]{1,100}$/'],
      Importe: ['required', 'decimal:2', 'min:0.00', 'regex:/^[0-9]{1,18}(.[0-9]{1,2})?$/'],
    };
  }

  componentDidMount() {
    this.fillCatalogs();
  }

  async componentDidUpdate() {
    const { data } = this.props;

    if (!!data) {
      const validator = this.validate(data);

      this.setState({
        data: { ...data },
        validator,
        isValid: validator.passes(),
      });
    }
  }

  fillCatalogs = async () => {
    if (!this.state.catalogos) {
      const values = await NominaCatalogoManager.get('c_nom_tipo_deduccion');

      if (!!values) {
        let catalogos = {};

        const sorted = _.sortBy(
          values.map((item) => {
            return {
              label: `${item.descripcion} (${item.tipo})`,
              value: item.tipo,
            };
          }),
          'value'
        );

        catalogos.tipoDeduccion = sorted;

        this.setState({
          catalogos,
        });
      }
    }
  };

  validate = (data) => {
    const validator = new Validator(data, this.rules);

    validator.check();

    return validator;
  };

  handleOnChange = (values) => {
    const data = {
      ...this.state.data,
      ...values,
    };

    const validator = this.validate(data);

    this.setState({
      data,
      validator,
      isValid: validator.passes(),
    });
  };

  handleOnAdd = () => {
    this.props.onAdd(this.state.data);

    this.setState({
      data: {},
      isValid: false,
    });
  };

  render() {
    const rules = this.rules;
    const { isValid, data = {}, catalogos = {} } = this.state;

    return (
      <>
        <Row>
          <Col>
            <FormControl
              type="ahead"
              label="Tipo Deducción"
              name="TipoDeduccion"
              placeholder=""
              help=""
              options={catalogos.tipoDeduccion}
              rules={rules.TipoDeduccion}
              value={data.TipoDeduccion}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Clave"
              name="Clave"
              placeholder=""
              help=""
              minLength="3"
              maxLength="15"
              rules={rules.Clave}
              value={data.Clave}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Concepto"
              name="Concepto"
              placeholder=""
              help=""
              minLength="1"
              maxLength="100"
              rules={rules.Concepto}
              value={data.Concepto}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            sm
            md={4}
          >
            <FormControl
              type="text"
              label="Importe"
              name="Importe"
              placeholder=""
              help=""
              min="0"
              rules={rules.Importe}
              value={data.Importe}
              onChange={this.handleOnChange}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <p className="text-muted">
              Puedes agregar varias deducciones usando el botón "Agregar deducción", las deducciones se mostrarán en la
              tabla de deducciones.
            </p>
          </Col>
        </Row>

        <Row>
          <Col className="text-right">
            <Button
              variant="secondary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar deducción
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default NominaDeduccionForm;
